import React from "react";
import cn from "classnames";
import ReactMarkdown from 'react-markdown';

import "./style.scss";

const RangeValue = ({
  id,
  placeholder,
  name,
  disabled,
  placeholdervalue,
  min,
  max,
  value,
  onChange,
  minmaxformatter,
  overnight,
  hideSlider = false,
  infoText,
}) => {
  const [focused, setFocused] = React.useState(false);
  const [localValue, setLocalValue] = React.useState(value);

  // Add useEffect to update localValue when value prop changes
  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const localChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(e);
  };

  const handleRangeChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    onChange(e);
  };

  const mixmaxformatter = minmaxformatter ? minmaxformatter : (x) => x;
  const minError =
    localValue < min
      ? name === "overnight" && !overnight?.status
        ? ""
        : "errorlimit"
      : "";
  const maxError =
    localValue > max
      ? name === "overnight" && !overnight?.status
        ? ""
        : "errorlimit"
      : "";

  const props = {
    id,
    name,
    disabled,
    placeholdervalue,
    min,
    max,
    value: localValue,
    onChange: handleRangeChange,
  };

  // Update the renderers object
  const renderers = {
    a: ({children, href}) => (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  };

  return (
    <div
      className={cn("rangevalue", {
        "opacity-element": name === "overnight" && !overnight?.status,
        inRow: hideSlider,
      })}
    >
      <div className="placeholder-wrapper">
        <div className="placeholder-with-info">
          <span className="placeholder">{placeholder}</span>
          {infoText && (
            <div className="info-icon-wrapper">
              <img 
                src={`${process.env.PUBLIC_URL}/info.svg`} 
                alt="info"
                className="info-icon"
              />
              <div className="info-tooltip">
                <ReactMarkdown components={renderers}>{infoText}</ReactMarkdown>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="d-flex">
        {!hideSlider && (
          <div className="rangeslider">
            <span className={`min ${minError}`}>{mixmaxformatter(min)}</span>
            <input type="range" {...props} onChange={handleRangeChange} />
            <span className={`max ${maxError}`}>{mixmaxformatter(max)}</span>
          </div>
        )}
        <input
          id={`input-field-${id}`}
          className={`placeholdervalue ${minError} ${maxError}`}
          type="text"
          disabled={disabled}
          value={focused ? localValue : "✎ " + placeholdervalue}
          onBlur={(e) => {
            setFocused(false);
            onChange(e, { min, max });
          }}
          onFocus={(e) => {
            setFocused(true);
            setLocalValue(value);
          }}
          onChange={localChange}
        />
      </div>
    </div>
  );
};

export default RangeValue;
